import { render, staticRenderFns } from "./SignDialog.vue?vue&type=template&id=591e2672&scoped=true"
import script from "./SignDialog.vue?vue&type=script&lang=js"
export * from "./SignDialog.vue?vue&type=script&lang=js"
import style0 from "./SignDialog.vue?vue&type=style&index=0&id=591e2672&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591e2672",
  null
  
)

export default component.exports